import { render, staticRenderFns } from "./CertificateOverview.vue?vue&type=template&id=095134c1&"
import script from "./CertificateOverview.vue?vue&type=script&lang=js&"
export * from "./CertificateOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports